module.exports = __webpack_public_path__ + "static/apple-PLmag-c71eddb47bc78fe73b59a4c5fd2a86a4.jpg";